import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconImages3"><Path d="M20 20L14 14L12 16L8 12L3.7 16.3M3.5 3.5H20.5V20.5H3.5V3.5ZM16 9C16 9.9665 15.2165 10.75 14.25 10.75C13.2835 10.75 12.5 9.9665 12.5 9C12.5 8.0335 13.2835 7.25 14.25 7.25C15.2165 7.25 16 8.0335 16 9Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconImages3;
